import React, { useEffect, useMemo, useState } from "react";
import fetchData from "../../api/fetchApi";
import Table from "../common/Table";
import PageHeader from "../common/PageHeader";
import { ArrowUpDown, Calendar } from "lucide-react";

export default function VoucherBatchesPage() {
  const [stats, setStats] = useState(null);
  const [batches, setBatches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchStats = async () => {
    try {
      const data = await fetchData("finance/voucher-batches/statistics");
      setStats(data.data || null);
    } catch (err) {
      setStats(null);
    }
  };

  const fetchBatches = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchData("finance/voucher-batches");
      setBatches(data.data || []);
    } catch (err) {
      setError(err.message || "حدث خطأ أثناء جلب البيانات");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
    fetchBatches();
  }, []);

  const columns = [
    { header: "رقم الدفعة", accessor: "batch_number" },
    { header: "الكمية", accessor: "quantity" },
    { header: "المتبقي", accessor: "batches_remaining" },
    { header: "السعر", accessor: "price" },
    { header: "الإجمالي", accessor: "total_price" },
    { header: "القيمة", accessor: "value" },
    { header: "العملة", accessor: "currency", render: row => row.currency?.name || "" },
    { header: "الحالة", accessor: "status" },
    { header: "الوصف", accessor: "description" },
    { header: "الموزع", accessor: "reseller", render: row => row.reseller?.name || "" },
  ];
  const miniStats = useMemo(() => {
    const s = stats || {};
    const total = s.new_this_month + s.updated_this_month;
 return [
    {
      title: "إجمالي الدُفعات",
      value: s.total_batches ?? 0,
      iconBg: "#2563EB",
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <rect
            x="4"
            y="4"
            width="16"
            height="16"
            rx="2"
            stroke="#fff"
            strokeWidth="2"
          />
        </svg>
      ),
    },
    {
      title: "الدُفعات النشطة",
      value: s.active_batches ?? 0,
      iconBg: "#059669",
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path
            d="M20 6L9 17l-5-5"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      title: "الدُفعات المنتهية",
      value: s.expired_batches ?? 0,
      iconBg: "#DC2626",
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 8v4l3 3"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="12" cy="12" r="9" stroke="#fff" strokeWidth="2" />
        </svg>
      ),
    },
    {
      title: "إجمالي القسائم",
      value: s.total_vouchers ?? 0,
      iconBg: "#6D28D9",
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path
            d="M3 7h18v10H3z"
            stroke="#fff"
            strokeWidth="2"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      title: "القسائم المستخدمة",
      value: s.used_vouchers ?? 0,
      iconBg: "#B45309",
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path
            d="M4 12h5m0 0a8 8 0 1 1 8 8"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      ),
    },
    {
      title: "القسائم غير المستخدمة",
      value: s.unused_vouchers ?? 0,
      iconBg: "#0EA5E9",
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path
            d="M5 12h14"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      ),
    },
    {
      title: "إجمالي السعر",
      value: `${s.total_price ?? 0} د.ل`,
      iconBg: "#F59E0B",
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 1v22M5 5h14M5 19h14"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      ),
    },
  ];
  }, [stats]);

  return (
    <div className="min-h-screen p-4 md:p-6 bg-white" dir="rtl">

      <PageHeader title="دفعات الفواتير" total={batches.length} stats={miniStats} />

      <Table  
      
      columns={columns} rows={batches} pagination={false} />
      {loading && <div className="text-center mt-4">جاري التحميل...</div>}
      {error && <div className="text-red-600 text-center mt-4">{error}</div>}
    </div>
  );
}
